"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsibleFilters = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireWildcard(require("react"));
var _CollapsibleFilters = require("./CollapsibleFilters.styles");
var _button = _interopRequireWildcard(require("@kyruus/button"));
var _SortFilter = _interopRequireDefault(require("@kyruus/react-ikons/SortFilter"));
var _uiTheme = require("@kyruus/ui-theme/");
var _intl = require("@kyruus/intl");
var _WeekDayFilter = require("../WeekDayFilter");
var _TimeFilter = require("../TimeFilter");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _moment = _interopRequireDefault(require("moment"));
var _JumpToDate = require("./JumpToDate");
var _styles = require("../styles");
var _utils = require("../../../lib/utils");
var _VisitTypeContent = _interopRequireDefault(require("../VisitTypeContent"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _defaultsDeepAll = _interopRequireDefault(require("lodash/fp/defaultsDeepAll"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const reducer = (state, action) => {
  switch (action.type) {
    case 'setSelectedLocations':
      {
        return {
          ...state,
          current: {
            ...state.current,
            selectedLocationIds: action.payload.selectedLocationIds,
            locationId: action.payload.locationId
          }
        };
      }
    case 'setDate':
      {
        return {
          ...state,
          current: {
            ...state.current,
            date: action.payload.date ?? ''
          }
        };
      }
    case 'setDayOfWeek':
      {
        return {
          ...state,
          current: {
            ...state.current,
            dayOfWeek: action.payload.dayOfWeek
          }
        };
      }
    case 'setTimeOfDay':
      {
        return {
          ...state,
          current: {
            ...state.current,
            timeOfDay: action.payload.timeOfDay
          }
        };
      }
    case 'setDateInvalid':
      {
        return {
          ...state,
          current: {
            ...state.current,
            dateInvalid: action.payload.dateInvalid
          }
        };
      }
    case 'apply':
      return state;
    case 'clear':
    default:
      return {
        ...state,
        current: action.payload
      };
  }
};
const BaseCollapsibleFilters = _ref => {
  var _context;
  let {
    initialState,
    offsetTop,
    intl,
    onExpand,
    onCollapse,
    onApplyFilters,
    onClearFilters,
    onSelectedLocationChange,
    onDateChange,
    onDayOfWeekChange,
    onTimeOfDayChange,
    config,
    ...props
  } = _ref;
  const withDefaults = (0, _defaultsDeepAll.default)([initialState, {
    filterCount: 0,
    dateInvalid: false,
    dayOfWeek: [],
    highlightedLocId: null,
    locationId: null,
    locsByAvailability: null,
    date: '',
    mapUrl: null,
    selectedLocationIds: new _set.default([]),
    timeOfDay: _TimeFilter.TIME_OF_DAY.ALL,
    visit_method: null
  }]);
  const [state, dispatch] = (0, _react.useReducer)(reducer, {
    initial: withDefaults,
    current: withDefaults
  });
  const color = _react.default.useMemo(() => (0, _uiTheme.fromTheme)('color_info')(props), []);
  const size = _react.default.useMemo(() => (0, _uiTheme.fromTheme)('font_size_heading_3')(props), []);
  const handleSelectedLocationChange = (0, _react.useCallback)((selectedLocationIds, locationId) => {
    dispatch({
      type: 'setSelectedLocations',
      payload: {
        selectedLocationIds,
        locationId
      }
    });
    if (onSelectedLocationChange) {
      onSelectedLocationChange(selectedLocationIds, locationId);
    }
  }, [onSelectedLocationChange]);
  const setDateInvalid = (0, _react.useCallback)(dateInvalid => {
    dispatch({
      type: 'setDateInvalid',
      payload: {
        dateInvalid
      }
    });
  }, []);
  const handleDateChange = (0, _react.useCallback)(date => {
    dispatch({
      type: 'setDate',
      payload: {
        date: date?.format('YYYY-MM-DD')
      }
    });
    if (onDateChange) {
      onDateChange(date?.format('YYYY-MM-DD'));
    }
  }, [onDateChange]);
  const handleDayOfWeekChange = (0, _react.useCallback)((_, dayOfWeek) => {
    dispatch({
      type: 'setDayOfWeek',
      payload: {
        dayOfWeek
      }
    });
    if (onDayOfWeekChange) {
      onDayOfWeekChange(dayOfWeek);
    }
  }, [onDayOfWeekChange]);
  const handleTimeOfDayChange = (0, _react.useCallback)((_, timeOfDay) => {
    dispatch({
      type: 'setTimeOfDay',
      payload: {
        timeOfDay
      }
    });
    if (onTimeOfDayChange) {
      onTimeOfDayChange(timeOfDay);
    }
  }, [onTimeOfDayChange]);
  const handleClearFilters = (0, _react.useCallback)(() => {
    dispatch({
      type: 'clear',
      payload: initialState
    });
    if (onClearFilters) {
      onClearFilters(state.current);
    }
  }, [initialState, onClearFilters, state]);
  const handleApplyFilters = (0, _react.useCallback)(() => {
    dispatch({
      type: 'apply'
    });
    if (onApplyFilters) {
      onApplyFilters(state.current);
    }
  }, [onApplyFilters, state]);
  return /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.Accordion, (0, _extends2.default)({
    mode: "single",
    defaultExpanded: false,
    offsetTop: offsetTop,
    headerText: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SortFilter.default, {
      "aria-hidden": "true",
      color: color,
      size: size
    }), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({
      tagName: "span"
    }, _messages.default.apptTimeFilterAppointments, {
      values: {
        filterCount: state.current.filterCount
      }
    }))),
    onExpand: onExpand,
    onCollapse: onCollapse
  }, props), /*#__PURE__*/_react.default.createElement(_styles.MapContainer, {
    "data-testid": "Map"
  }, (0, _utils.hasAnyVideoPhoneAppt)(state.current.visit_method) ? /*#__PURE__*/_react.default.createElement(_styles.ApptTimeLeftContainer, null, /*#__PURE__*/_react.default.createElement(_VisitTypeContent.default, {
    type: state.current.visit_method
  })) : /*#__PURE__*/_react.default.createElement(_styles.MapContent, null, /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.LocationsList, {
    selectedLocationIds: state.current.selectedLocationIds,
    highlightedLocId: state.current.highlightedLocId,
    url: state.current.mapUrl,
    bookableLocations: state.current.locsByAvailability.bookable,
    nonBookableLocations: state.current.locsByAvailability.nonBookable,
    onSelect: handleSelectedLocationChange,
    locationId: state.current.locationId,
    config: config
  }))), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterAvailableDates, FormattedMessage => /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.SectionHeader, null, FormattedMessage)), /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.Toolbar, {
    className: "FiltersToolbar"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterStartDate, FormattedMessage => /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.FilterLabel, {
    htmlFor: "FilterJumpToDateCalendar"
  }, FormattedMessage)), /*#__PURE__*/_react.default.createElement(_JumpToDate.JumpToDate, {
    ariaLabel: intl.formatMessage(_messages.default.ariaJumpToDateCalendarInput),
    date: state.current.date && (0, _moment.default)(state.current.date),
    dateInvalid: state.current.dateInvalid,
    hideKeyboardShortcutsPanel: true,
    id: "FilterJumpToDateCalendar",
    inputIconPosition: "after",
    numberOfMonths: 1,
    onDateChange: handleDateChange,
    onFocusChange: () => {},
    placeholder: intl.formatMessage(_messages.default.apptTimeCalendarPlaceholder),
    screenReaderInputMessage: intl.formatMessage(_messages.default.ariaJumpToDateInputDescription),
    setDateInvalid: setDateInvalid,
    showDefaultInputIcon: true,
    small: true
  }), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterDayOfWeek, FormattedMessage => /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.FilterLabel, {
    id: "FilterDayOfWeekLabel"
  }, FormattedMessage)), /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.SegmentedButtonGroup, {
    id: "FilterDayOfWeek",
    "data-testid": "WeekDayFilter",
    "aria-labelledby": "FilterDayOfWeekLabel",
    type: "multiple",
    value: state.current.dayOfWeek,
    onClick: handleDayOfWeekChange,
    isEqualFn: _isEqual.default
  }, (0, _map.default)(_WeekDayFilter.DAYS_OF_WEEK).call(_WeekDayFilter.DAYS_OF_WEEK, (day, index) => /*#__PURE__*/_react.default.createElement(_button.SegmentedButton, {
    key: day,
    value: index,
    "aria-label": day
  }, day.charAt(0)))), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterTimeOfDay, FormattedMessage => /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.FilterLabel, {
    id: "FilterTimeOfDayLabel"
  }, FormattedMessage)), /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.SegmentedButtonGroup, {
    id: "FilterTimeOfDay",
    "data-testid": "TimeFilter",
    "aria-labelledby": "FilterTimeOfDayLabel",
    type: "single",
    value: state.current.timeOfDay,
    onClick: handleTimeOfDayChange,
    isEqualFn: _isEqual.default
  }, (0, _map.default)(_context = (0, _keys.default)(_TimeFilter.TIME_OF_DAY)).call(_context, time => /*#__PURE__*/_react.default.createElement(_button.SegmentedButton, {
    key: time,
    value: time
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default[`timeOfDay.${time.toLowerCase()}`]))))), /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    mode: "ghost",
    onClick: handleClearFilters,
    "data-testid": "ClearFilters"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterClearFilters)), /*#__PURE__*/_react.default.createElement(_button.default, {
    mode: "primary",
    "data-testid": "ApplyFilters",
    disabled: state.current.dateInvalid,
    onClick: handleApplyFilters
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterApplyFilters))));
};
const CollapsibleFilters = exports.CollapsibleFilters = (0, _intl.injectIntl)(BaseCollapsibleFilters);
BaseCollapsibleFilters.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BaseCollapsibleFilters"
};